// import { FaGithub, FaLink } from "react-icons/fa";

const Card = ({ project = {} }) => {
  const { image, title, tags, description } = project;

  return (

    <div className="w-[400px] h-[380px] perspective mx-4 my-6">
      <div className="relative w-full h-full transition-transform duration-700 transform-style-preserve-3d group hover:rotate-y-180">
        {/* Front Side */}
        <div className="absolute w-full h-full backface-hidden rounded-[20px] bg-[#1b233d] p-4 shadow-[rgba(100,100,111,0.2)_0px_7px_20px_0px] flex flex-col">
          {/* Image Area (Fixed Height) */}
          <div className="h-[240px] rounded-[15px] relative overflow-hidden mb-3">
            {image ? (
              <img
                src={image}
                alt={title}
                className="w-full h-full object-cover rounded-[15px]"
              />
            ) : (
              <div className="w-full h-full bg-gradient-to-tr from-cyan-700 to-cyan-300 rounded-[15px] flex items-center justify-center">
                <p className="text-white text-sm font-semibold">No Image</p>
              </div>
            )}

            {/* Mern Digital label */}
            <div className="absolute top-0 left-2 z-10 ">
              <p className="bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent text-[18px] font-semibold">
                Mern Digital
              </p>
            </div>

            {/* Decorative corners */}
            <div className="absolute top-0 left-0 h-[30px] w-[130px] bg-[#1b233d] skew-x-[-40deg] rounded-br-[10px] shadow-[-10px_-10px_0_0_#1b233d]" />
            <div className="absolute top-[30px] left-0 w-[15px] h-[15px] bg-transparent rounded-tl-[15px] shadow-[-5px_-5px_0_2px_#1b233d]" />
          </div>

          {/* Title Area (Fixed Height) */}
          <div className="h-[28px] flex items-center justify-center mb-1">
            <span className="text-lg font-bold text-white tracking-[2px] truncate max-w-full">
              {title || "Untitled"}
            </span>
          </div>

          {/* Tags Area (Fixed Height) */}
          <div className="h-[28px] flex flex-wrap justify-center items-center gap-1 mb-2 overflow-hidden">
            {tags?.map((tag, index) => (
              <span
                key={index}
                className="text-[14px] px-2 py-0.5 bg-gray-700 text-white rounded-full whitespace-nowrap"
              >
                {tag}
              </span>
            ))}
          </div>

          {/* Description Area (Flexible Height) */}
          <div className="flex-grow min-h-[40px] max-h-[80px] overflow-y-auto text-center">
            <p className="text-[13px] text-white line-clamp-4">
              {description || "No description available"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;